import { IconProps } from '../../Icon.types';

export const Competencies3DIcon = ({ width, height, color }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_i_3982_59687)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.9996 4.80005C24.6976 4.80005 20.3996 9.09812 20.3996 14.4C20.3996 19.702 24.6976 24 29.9996 24C35.3015 24 39.5996 19.702 39.5996 14.4C39.5996 9.09812 35.3015 4.80005 29.9996 4.80005ZM23.9996 14.4C23.9996 17.7138 26.6859 20.4 29.9996 20.4C33.3133 20.4 35.9996 17.7138 35.9996 14.4C35.9996 11.0863 33.3133 8.40005 29.9996 8.40005C26.6859 8.40005 23.9996 11.0863 23.9996 14.4Z"
          fill={color}
        />
        <path
          d="M16.876 15.5273C17.579 16.2302 17.579 17.3699 16.876 18.0729L8.47593 26.4728C7.77298 27.1758 6.63329 27.1758 5.93035 26.4728L1.12681 21.6693C0.423872 20.9663 0.423875 19.8266 1.12682 19.1237C1.82977 18.4207 2.96946 18.4207 3.6724 19.1237L7.20316 22.6545L14.3305 15.5272C15.0334 14.8243 16.1731 14.8243 16.876 15.5273Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.9996 25.8C25.7417 25.8 21.8891 26.48 19.0865 27.9639C16.2796 29.4501 14.3996 31.8254 14.3996 35.25C14.3996 36.9024 15.0422 38.1725 16.0472 39.0024C17.0265 39.8111 18.3422 40.2001 19.7774 40.2001H40.2218C41.657 40.2001 42.9727 39.8111 43.952 39.0024C44.957 38.1725 45.5996 36.9024 45.5996 35.25C45.5996 31.8254 43.7196 29.4501 40.9127 27.9639C38.1101 26.48 34.2576 25.8 29.9996 25.8ZM20.7711 31.1455C22.8471 30.0462 26.0376 29.4 29.9996 29.4C33.9616 29.4 37.1522 30.0462 39.2281 31.1455C41.1341 32.1546 41.9996 33.4459 41.9996 35.25C41.9996 35.5968 41.9361 35.8118 41.8777 35.9398C41.82 36.0662 41.7457 36.1555 41.6597 36.2266C41.4741 36.3798 41.0357 36.6 40.2218 36.6H19.7774C18.9635 36.6 18.5251 36.3798 18.3396 36.2266C18.2535 36.1555 18.1792 36.0662 18.1215 35.9398C18.0631 35.8118 17.9996 35.5968 17.9996 35.25C17.9996 33.4459 18.8652 32.1546 20.7711 31.1455Z"
          fill={color}
        />
      </g>
      <defs>
        <filter
          id="filter0_i_3982_59687"
          x="-0.400391"
          y="4.80005"
          width="46"
          height="36.3999"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-1" dy="1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3982_59687"
          />
        </filter>
      </defs>
    </svg>
  );
};
